/**
 * zipファイルのダウンロードを行う
 * @param blob ファイル実体
 * @param fileName ファイル名
 * @returns なし
 */
export const downloadZipFile = async (blob: Blob, fileName: string): Promise<void> => {
  const blobURL = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobURL
  a.download = fileName
  a.click()
  a.remove()
  URL.revokeObjectURL(blobURL)
}
